import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  IconButton,
  useTheme,
  CircularProgress,
} from "@mui/material";
import { motion } from "framer-motion";
import LockIcon from "@mui/icons-material/Lock";
import EmailIcon from "@mui/icons-material/Email";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import scannedIcon from "../../../src/assets/printer.png";
import DocumentIcon from "../../../src/assets/digitalpdf.png";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import uploadbigIcon from "../../../src/assets/backup-file";
import { CloudUploadIcon } from "lucide-react";

const MotionCard = motion(Card);

const UploadDocumentsMain = ({setDocType}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [uploading, setUploading] = useState(false);
  const [fileName, setFileName] = useState("");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);
      setUploading(true);
      // Simulate upload process
      setTimeout(() => {
        setUploading(false);
        // Handle successful upload or error
      }, 2000);
    }
  };
  const settings = [
    {
      title: "Upload Scanned Copies",
      description: "Upload scanned copies here...",
      icon: scannedIcon,
      path: "/upload-type-document",
      type:"scanned"
    },
    {
      title: "Upload Digital Copies",
      description: "Upload digital copies here...",
      icon: DocumentIcon,
      path: "/upload-type-document",
      type:"digital"
    },
  ];
  const handleNaigatetoGeneralScreens = (path,type) => {
    navigate(path);
    console.log(type,'doctype');
    
    if(type==="scanned"){
        setDocType(true);
    }else{
        setDocType(false);
    }
  };
  return (
    <>
      <Box sx={{justifyContent: "center" }}>
        <div
          className="d-flex justify-content-center"
          style={{ margin: "auto" }}
        >
          <img src={uploadbigIcon} alt="cloudIcon" style={{height:'350px'}} />
        </div>
        <Grid
          container
          spacing={2}
          sx={{
            justifyContent: "center",
            alignItems: "center",
            marginTop: "20px",
          }}
        >
          {settings.map((setting, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={4}
              key={index}
              sx={{
                display: "flex",
                justifyContent: "center",
                width: { xl: "24%", sm: "48%", md: "30%", xs: "100%" },
              }}
            >
              <MotionCard
                onClick={() => handleNaigatetoGeneralScreens(setting.path,setting.type)}
                whileHover={{
                  scale: 1.03,
                  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
                  cursor: "pointer",
                }}
                whileTap={{ scale: 0.98 }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  delay: index * 0.1,
                  type: "spring",
                  stiffness: 120,
                }}
                sx={{
                  width: "100%",
                  height: "100%",
                  maxWidth: "100%",
                  // height:200,
                  borderRadius: 4,
                  boxShadow: 2,
                  p: 2,

                  background: theme.palette.background.paper,
                  transition: "all 0.3s ease-in-out",
                }}
              >
                <CardContent>
                  <Box
                    display="flex"
                    alignItems="center"
                    flexDirection="column"
                    mb={1.5}
                  >
                    <img src={setting.icon} alt="scannedCopies" />
                    <Typography variant="h6" sx={{ fontWeight: 500 }}>
                      {setting.title}
                    </Typography>
                  </Box>
                </CardContent>
              </MotionCard>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default UploadDocumentsMain;
